import { render, staticRenderFns } from "./PriceIndicationSelectFavouriteProducts.vue?vue&type=template&id=9d7e5190"
import script from "./PriceIndicationSelectFavouriteProducts.vue?vue&type=script&lang=js"
export * from "./PriceIndicationSelectFavouriteProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports